import React from 'react'
import { Redirect, Route, useLocation } from 'react-router-dom'
import { useUser } from '../contexts/user';

import Loading from '../components/Loading';


const PrivateRoute = ({ component: Component, ...rest }) => {
    const { user } = useUser();
    const location = useLocation();

    const RedirectToLogin = () => {
        localStorage.setItem('postLoginURL', location.pathname + location.search);
        return <Redirect to="/login" />
    }

    return (
        <Route {...rest}
            render={props => user ? user.isLoading 
                ? <Loading /> : <Component user={user} {...props} {...rest} />
                : <RedirectToLogin/>}
        />);
}

export default PrivateRoute